export const MESSAGES_DRAWER_STAGES = {
  INITIAL: 'initial',
  MESSAGE: 'message',
}
